import React, { FC } from 'react';
import { ProjectPhaseStartDateChanged } from 'api/notifications/meta';
import { useExternalIntegrationUserDetails } from 'hooks/use-external-integration-user-details';
import { ProjectPhaseFieldChangedMessage } from './project-phase-field-changed';

export const ProjectPhaseStartDateChangedView: FC<{
  meta: ProjectPhaseStartDateChanged;
}> = ({ meta: { phaseName, by, from, to, externalUser } }) => {
  const userDetails = useExternalIntegrationUserDetails(externalUser, by);

  return (
    <ProjectPhaseFieldChangedMessage
      by={userDetails}
      name="start_date"
      phase={phaseName}
      from={from}
      to={to}
    />
  );
};
